import { useQuery } from 'react-query';
import { useAxios } from '../../contexts/axios';

/** Redis instances (metadata for unit costing). */
const REDIS_INSTANCES_PATH = '/redis/instances';

const getRedisInstancesMetadata = async (authAxios) => {
    try {
        const { data } = await authAxios.get(REDIS_INSTANCES_PATH);
        return data;
    } catch (e) {
        console.error(e);
    }
};

const useRedisInstancesMetadata = () => {
    const authAxios = useAxios();

    return useQuery(['redis-instances'], () =>
        getRedisInstancesMetadata(authAxios)
    );
};

export { useRedisInstancesMetadata };
